import { render, staticRenderFns } from "./LinkedContacts.vue?vue&type=template&id=cc5ead64&scoped=true"
import script from "./LinkedContacts.vue?vue&type=script&lang=js"
export * from "./LinkedContacts.vue?vue&type=script&lang=js"
import style0 from "./LinkedContacts.vue?vue&type=style&index=0&id=cc5ead64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5ead64",
  null
  
)

export default component.exports